export const accessToken = process.env.REACT_APP_MAP_TOKEN;
export const mapStyle = process.env.REACT_APP_MAP_STYLE;
export const mapboxUrl = process.env.REACT_APP_MAPBOX_API;
export const geoserverUrl = process.env.REACT_APP_GEOSERVER_HOST;
